import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {SalesService} from '../../services/sales.service';
import {MarketingDataRequest} from '../../models/marketingData.request';
import {EventsManager} from '../../events/events.manager';
import {PlanViewTypeEnum} from '../../enums/plan-view-type.enum';
import {resolveXrayExamStatement} from '../../utils/xray-exam-statement.util';
import {CATEGORY_SAVINGS_MARKER, FOOTER_GROUP_NAME} from '../../constants/marketing-detail.constants';
import {CategorySavingsSplitInterface, splitCategorySavings} from '../../utils/category-savings/category-savings.util';
import {FeeScheduleRowInterface, FeeScheduleSectionInterface} from '../../models/fee-schedule.model';

@Component({
  selector: 'app-fee-schedule',
  templateUrl: './fee-schedule.component.html',
  styleUrls: ['./fee-schedule.component.scss'],
  standalone: false
})

export class FeeScheduleComponent implements OnInit {
  private _eventsManager: EventsManager = inject(EventsManager);
  private _salesService: SalesService = inject(SalesService);
  private _destroyRef: DestroyRef = inject(DestroyRef);

  public readonly PlanViewType: typeof PlanViewTypeEnum = PlanViewTypeEnum;
  public readonly FOOTER_GROUP: string = FOOTER_GROUP_NAME;
  public currentCovLevel: number = 0;
  private _feeScheduleInfo: any = {};
  public selectedPlan: any = {};
  public footer: string = 'X%';
  public details: any = {};
  public plans: any = {};

  public ngOnInit(): void {
    this.plans = this._eventsManager.getOfficeInfo();
    this._feeScheduleInfo = this._eventsManager.getFeeScheduleInfo();
    this.selectedPlan = this.plans.benefitPlanTemplates?.find((x: {benefitPlanTemplateId: any}) => x.benefitPlanTemplateId == this._feeScheduleInfo.templateId);
    this.getFeeSchedule(this.currentCovLevel);

    this._eventsManager.feeScheduleUpdate
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((result: any) => {
        this._feeScheduleInfo = result;
      });
  }

  public getXrayExamStatement(): string {
    return resolveXrayExamStatement(this.details?.salesPlanMarketingDetails?.commonDentalPlanSavings?.xrayExamFooterText);
  }

  public getSplit(section: FeeScheduleSectionInterface): CategorySavingsSplitInterface<FeeScheduleRowInterface> {
    return splitCategorySavings(section && section.value, (row) => row.column1 === CATEGORY_SAVINGS_MARKER, (row) => row.column2);
  }

  public hasAnyVisibleRows(): boolean {
    const sections: FeeScheduleSectionInterface[] | undefined = this.details?.salesPlanMarketingDetails?.default;
    if (!sections) { return false; }
    return sections.some((section) => section.itemName !== FOOTER_GROUP_NAME && this.getSplit(section).visible.length > 0);
  }

  public headerCellClasses(hasSavings: boolean, isRight: boolean): {[key: string]: boolean} {
    const anyVisible: boolean = this.hasAnyVisibleRows();
    return {
      'section-header': anyVisible,
      'mt-3': anyVisible,
      'mb-2': anyVisible,
      'text-bold': anyVisible,
      'mb-3': !anyVisible,
      'col-6': hasSavings || isRight,
      'col-12': !hasSavings && !isRight,
      'text-right': isRight
    };
  }

  public getFeeSchedule(level: number) {
    this.currentCovLevel = level;
    const params: MarketingDataRequest = {practice: this._feeScheduleInfo.practiceId, template: this._feeScheduleInfo.templateId, coverageLevelName: this.selectedPlan.coverageLevels[this.currentCovLevel].caption, pageName: this._feeScheduleInfo.pageName};
    this._salesService.getMarketingDetails(params)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((result: any) => {
        this.details = result;
        this.details.salesPlanMarketingDetails?.default?.forEach((item: FeeScheduleSectionInterface) => {
          if (item.itemName === FOOTER_GROUP_NAME) {
            this.footer = item.value[0].column1;
          }
        });
      });
  }
}
